// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.navbar {
  background-color: #405cf5;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  height: calc(10px + 5vmin);
}

.success-message {
  color: #270;
  background-color: #DFF2BF;
}

.error-message {
  color: red;
  background-color: #DFF2BF;
}

.font-awesome-check {
  color: green;
}

.font-awesome-cross {
  color: red;
}

.response-message-div {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  position: relative;
  left: 5%;
}

.confirmationModal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  height: 150px;
  background-color: white;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
  text-align: center;
  align-content: center;
}

.modalButton {
  margin: 0.5rem;
}

.loadingCircle {
  padding: 10rem;
}

.submit-button {
  width: 180px;
  margin-top: 15px;
  height: 40px;
  border: none;
  outline: none;
  background: #2f2f2f;
  color: #fff;
  float: right;
  font-size: 16px;
  border-radius: 40px;
  text-align: center;
  box-shadow: 0 6px 20px -5px rgba(0,0,0,0.4);
  position: relative;
  cursor: pointer;
}

.link-class {
  padding: 0 30px;
  color: white;
  text-transform: uppercase;
  text-decoration: none;
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,0CAA0C;EAC1C,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":[".App {\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.navbar {\n  background-color: #405cf5;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  height: calc(10px + 5vmin);\n}\n\n.success-message {\n  color: #270;\n  background-color: #DFF2BF;\n}\n\n.error-message {\n  color: red;\n  background-color: #DFF2BF;\n}\n\n.font-awesome-check {\n  color: green;\n}\n\n.font-awesome-cross {\n  color: red;\n}\n\n.response-message-div {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 40px;\n  position: relative;\n  left: 5%;\n}\n\n.confirmationModal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 500px;\n  height: 150px;\n  background-color: white;\n  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  align-content: center;\n}\n\n.modalButton {\n  margin: 0.5rem;\n}\n\n.loadingCircle {\n  padding: 10rem;\n}\n\n.submit-button {\n  width: 180px;\n  margin-top: 15px;\n  height: 40px;\n  border: none;\n  outline: none;\n  background: #2f2f2f;\n  color: #fff;\n  float: right;\n  font-size: 16px;\n  border-radius: 40px;\n  text-align: center;\n  box-shadow: 0 6px 20px -5px rgba(0,0,0,0.4);\n  position: relative;\n  cursor: pointer;\n}\n\n.link-class {\n  padding: 0 30px;\n  color: white;\n  text-transform: uppercase;\n  text-decoration: none;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
